var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('b-modal', {
    attrs: {
      "visible": _setup.visible,
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "centered": "",
      "aria-label": _vm.$t('auth.callback.failed'),
      "content-class": "auth-recovery-dialog"
    }
  }, [_c(_setup.AuthCallbackContent, {
    attrs: {
      "busy": _setup.busy,
      "failed": !_setup.busy,
      "show-slow": false,
      "show-actions": !_setup.busy,
      "message": _vm.$t('auth.callback.failed'),
      "slow-message": _vm.$t('auth.callback.takingLonger'),
      "try-again-label": _vm.$t('auth.callback.tryAgain'),
      "reload-label": _vm.$t('auth.callback.reload')
    },
    on: {
      "try-again": _setup.retry,
      "reload": _setup.reload
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };